import { useEffect, useRef, useState } from 'react'
import { Tooltip, ITooltipProps, Flex } from 'components'
import styled from '@emotion/styled'

const Label = styled('div')`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const TooltipWhenEllipsis = ({
  text,
  ...passingProps
}: ITooltipProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isOverflown, setIsOverflown] = useState<boolean>(true)
  useEffect(() => {
    const element = ref.current
    setIsOverflown((element?.scrollWidth || 0) > (element?.clientWidth || 0))
  }, [])

  return (
    <Flex>
      {isOverflown ? (
        <Tooltip {...passingProps} text={text}>
          <Label ref={ref}>{text}</Label>
        </Tooltip>
      ) : (
        <Label>{text}</Label>
      )}
    </Flex>
  )
}
